import { API_URL, API_URL_LOCAL_DEV, API_URL_DEV } from "../../env";
import { Get, Post } from "../consumir";


const API_CALL = API_URL;
interface SaveSubscriptionMercadoPagoProps {
  preapproval_plan_id: string;
  reason: string;
  payer_email: string;
  card_token_id: string;
  back_url: string;
  transaction_amount?: number;
  external_reference?: string;
  currency_id?: string;
  frequency?: string;
  frequency_type?: "days" | "months";
}
//queries
export const getPlanMPById = async (idPlan: string) => {
  try {
    const response = await Get(
      `${API_CALL}/subscriptions/mp/get-plan/${idPlan}`
    );
    return response;
  } catch (error) {
    console.error("ERROR NETWORK CONNECTION TO GET PLAN", error);
  }
};

//mutations
export const generatePaymentToken = async (data: {
  transaction_amount: number;
  token: string;
  description: string;
  installments: number;
  payment_method_id: string;
  issuer_id: number;
  payer: {
    email: string;
    identification: {
      type: string;
      number: string;
    };
  };
}) => {
  try {
    const response = await Post(
      `${API_CALL}/subscriptions/mp/create-payment`,
      data
    );
    return response;
  } catch (error) {
    console.error("ERROR NETWORK CONNECTION TO GENERATE PAYMENT TOKEN", error);
  }
};

export const createSuscriptionMP = async (data: {
  preapproval_plan_id: string;
  reason: string;
  payer_email: string;
  card_token_id: string;
  back_url?: string;
  external_reference?: string;
  auto_recurring: {
    frequency: number;
    frequency_type: "days" | "months";
    start_date: string;
    end_date: string;
    transaction_amount: number;
    currency_id: string;
  };
  player_id: number;
  updateType?: 'subscription' | 'update' | 'cancel';
  recurring_type?:'monthly'|'yearly';
}) => {

  try {
    const response = await Post(
      `${API_CALL}/subscriptions/mp/create-subscription`,
      data
    );
    return response;
  } catch (error) {
    console.error("ERROR NETWORK CONNECTION TO GENERATE SUBSCRIPTION", error);
  }
};

export const subscriptionPlanMercadoPago = async (
  data: SaveSubscriptionMercadoPagoProps
) => {
  //console.log("Que le estoy mandando a la data? para suscripcion", data);
  try {
    const response = await Post(
      `${API_CALL}/subscriptions/mp/create-subscription`,
      data
    );

    return response;
  } catch (error) {
    console.error(
      "ERROR NETWORK CONNECTION TO SUBSCRIBE PLAN MERCADOPAGO",
      error
    );
  }
};
